import React, { useEffect, useState } from "react";
import style from "css/solution.module.scss";
import Questions from "components/app/questions";
import SEOMeta from "components/app/SEOMeta";
import Consult from "components/device/neat/consult";

function BeGate(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <SEOMeta
        title="Be Gate, 리브테크놀로지"
        description="리브테크놀로지 riv Technology - Be Gate,"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 회의실, 화상회의, Be Gate, 클라우드 화상회의, 솔루션"
      />
      <section className={style.wrapper}>
        <section className={`${style.container} ${style.be_gate_content}`}>
          <section className={style.banner_section}>
            <article className={style.banner_article}>
              <p>
                <font>사내 어플리케이션</font>과 <font>클라우드 화상회의</font>
                를
              </p>
              <p>원활하게 연결하는 최적의 솔루션</p>
            </article>
            <img
              className={style.banner_logo}
              src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/banner_logo.png`}
              alt="banner"
            />
            <div
              className={style.banner_card}
              style={{
                backgroundImage:
                  "url('" +
                  process.env.REACT_APP_CLIENT_URL +
                  "img/solution/begate/banner_card.png')",
              }}
            >
              {isMobile ? (
                <>
                  <p>BeGate는</p>
                  <p>Webex, Zoom과 같은</p>
                  <p>클라우드 화상회의 플랫폼과</p>
                  <p>사내 어플리케이션을</p>
                  <p>손쉽게 통합할 수 있는</p>
                  <p>강력한 Gateway 솔루션 입니다</p>
                </>
              ) : (
                <>
                  <p>BeGate는</p>
                  <p>Webex, Zoom과 같은 클라우드 화상회의 플랫폼과</p>
                  <p>사내 어플리케이션을</p>
                  <p>손쉽게 통합할 수 있는</p>
                  <p>강력한 Gateway 솔루션 입니다</p>
                </>
              )}
            </div>
            <div className={style.banner_configuration}>
              <p className={style.banner_configuration_title}>구성도</p>
              <article className={style.banner_configuration_article}>
                {isMobile ? (
                  <>
                    <p>Be Gate는 고객 시스템과 Zoom, Webex 등의</p>
                    <p>회의 연동을 안전하고 간편하게 연결하는</p>
                    <p>API 게이트웨이입니다.</p>
                  </>
                ) : (
                  <>
                    <p>Be Gate는 고객 시스템과 Zoom, Webex 등의 회의 연동을</p>
                    <p>안전하고 간편하게 연결하는 API 게이트웨이입니다.</p>
                  </>
                )}
              </article>
              <div className={style.banner_configuration_diagram}>
                <div className={style.banner_configuration_customer}>
                  <div className={style.customer_main_item}>
                    <p>고객</p>
                    <p>Application</p>
                  </div>
                  <div className={style.customer_sub_item}>
                    <img
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/icon_bdu.png`}
                      alt=""
                    />
                  </div>
                  <div className={style.customer_sub_item}>
                    <img
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/icon_wdu.png`}
                      alt=""
                    />
                  </div>
                  <div className={style.customer_sub_item}>
                    <img
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/icon_cju.png`}
                      alt=""
                    />
                  </div>
                  <div className={style.customer_sub_item}>
                    <img
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/icon_lotte.png`}
                      alt=""
                    />
                  </div>
                </div>
                <div className={style.banner_configuration_arrow}>
                  <p>회의 개설 요청</p>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/banner_arrow_right.png`}
                    alt=""
                  />
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/banner_arrow_left.png`}
                    alt=""
                  />
                  <p>개설완료 정보 Update</p>
                </div>
                <div className={style.banner_configuration_logo}>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/banner_logo.png`}
                    alt=""
                  />
                </div>
                <div className={style.banner_configuration_arrow}>
                  <p>API 회의 개설</p>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/banner_arrow_right.png`}
                    alt=""
                  />
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/banner_arrow_left.png`}
                    alt=""
                  />
                  <p>개설 완료 정보</p>
                </div>
                <div className={style.banner_configuration_av}>
                  <div className={style.configuration_av_item}>
                    <img
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/ci_zoom.png`}
                      alt=""
                    />
                  </div>
                  <div className={style.configuration_av_item}>
                    <img
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/ci_webex.png`}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className={style.features_section}>
            <p className={style.features_title}>주요 연동 기능</p>
            <div className={style.features_info}>
              <article className={style.features_list}>
                <div className={style.features_item}>
                  <div className={style.features_icon}>
                    <img
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/feature_icon_schedule.png`}
                      alt="banner"
                    />
                  </div>
                  <article className={style.features_item_info}>
                    <p className={style.features_item_title}>1. 일정 관리</p>
                    <p className={style.features_item_description}>
                      회의에 따른 일정 관리 (생성 / 수정 / 삭제 / 조회)
                    </p>
                  </article>
                </div>
                <div className={style.features_item}>
                  <div className={style.features_icon}>
                    <img
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/feature_icon_record.png`}
                      alt="banner"
                    />
                  </div>
                  <article className={style.features_item_info}>
                    <p className={style.features_item_title}>2. 녹화 관리</p>
                    <p className={style.features_item_description}>
                      회의 녹화 및 녹화파일 다운로드 관리
                    </p>
                  </article>
                </div>
                <div className={style.features_item}>
                  <div className={style.features_icon}>
                    <img
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/feature_icon_join.png`}
                      alt="banner"
                    />
                  </div>
                  <article className={style.features_item_info}>
                    <p className={style.features_item_title}>3. 접속 관리</p>
                    <p className={style.features_item_description}>
                      회의 접속 관련 제어 (호스트 / 참석자)
                    </p>
                  </article>
                </div>
                <div className={style.features_item}>
                  <div className={style.features_icon}>
                    <img
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/feature_icon_log.png`}
                      alt="banner"
                    />
                  </div>
                  <article className={style.features_item_info}>
                    <p className={style.features_item_title}>
                      4. 참석자 로그 관리
                    </p>
                    <p className={style.features_item_description}>
                      회의 참석자 및 호스트 접속 통계 관리
                    </p>
                  </article>
                </div>
              </article>
              <img
                src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/feature_img.png`}
                alt="banner"
              />
            </div>
          </section>
          <section className={style.client_section}>
            <article className={style.client_article_container}>
              <p className={style.client_article_title}>Be Gate의 Client</p>
              <div className={style.client_article_desc}>
                <p>Be Gate는 의료기관부터 교육기관까지</p>
                <p>많은 클라이언트들과 함께하고 있습니다.</p>
                <p>Webex, Zoom과 같은 클라우드 화상회의</p>
                <p>플랫폼과의 원활한 연동을 통해,</p>
                <p>각 기관의 협업과 소통을 혁신적으로 개선하세요.</p>
              </div>
            </article>
            <div className={style.client_list_container}>
              <div className={style.client_list}>
                <div className={style.client_item}>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/ci_wdu.png`}
                    alt=""
                  />
                  <article className={style.client_item_article}>
                    <p className={style.client_item_title}>원광디지털대학교</p>
                    <ul className={style.client_item_desc}>
                      <li>원격강의를 위해 LMS와 Webex 연동 지원</li>
                    </ul>
                  </article>
                </div>
              </div>
              <div className={style.client_list}>
                <div className={style.client_item}>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/ci_multicampus.png`}
                    alt=""
                  />
                  <article className={style.client_item_article}>
                    <p className={style.client_item_title}>삼성멀티캠퍼스</p>
                    <ul className={style.client_item_desc}>
                      <li>추가 기능 개발 구축</li>
                      <li>자체 LMS와의 연동을 통한 Webex, Zoom 연동 지원</li>
                      <li>녹스미팅 API GW 개발 구축</li>
                    </ul>
                  </article>
                </div>
                <div className={style.client_item}>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/ci_bdu.png`}
                    alt=""
                  />
                  <article className={style.client_item_article}>
                    <p className={style.client_item_title}>부산디지털대학교</p>
                    <ul className={style.client_item_desc}>
                      <li>원격강의를 위해 LMS와 Webex 연동 지원</li>
                    </ul>
                  </article>
                </div>
                <div className={style.client_item}>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/ci_webinars.png`}
                    alt=""
                  />
                  <article className={style.client_item_article}>
                    <p className={style.client_item_title}>(주)웨비나스</p>
                    <ul className={style.client_item_desc}>
                      <li>웨비나 서비스를 위한 Webex Event API 적용</li>
                    </ul>
                  </article>
                </div>
              </div>
              <div className={style.client_list}>
                <div className={style.client_item}>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/ci_lotte.png`}
                    alt=""
                  />
                  <article className={style.client_item_article}>
                    <p className={style.client_item_title}>롯데그룹</p>
                    <ul className={style.client_item_desc}>
                      <li>Cisco Teams API 연동 구축</li>
                      <li>롯데 DWP 구축 사업에 포함 (사내 포탈 연동)</li>
                    </ul>
                  </article>
                </div>
                <div className={style.client_item}>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/ci_dream_class.png`}
                    alt=""
                  />
                  <article className={style.client_item_article}>
                    <p className={style.client_item_title}>삼성 드림클래스</p>
                    <ul className={style.client_item_desc}>
                      <li>원격강의를 위해 LMS와 Webex 연동 지원</li>
                    </ul>
                  </article>
                </div>
                <div className={style.client_item}>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/ci_mint.png`}
                    alt=""
                  />
                  <article className={style.client_item_article}>
                    <p className={style.client_item_title}>
                      민트영어 ( 에듀서브 )
                    </p>
                    <ul className={style.client_item_desc}>
                      <li>
                        온라인 학습 플랫폼(LMS)과 Webex 연동 구축 1:1 전화영어를
                        영상회의로 대체하여 서비스
                      </li>
                    </ul>
                  </article>
                </div>
              </div>
              <div className={style.client_list}>
                <div className={style.client_item}>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/ci_cju.png`}
                    alt=""
                  />
                  <article className={style.client_item_article}>
                    <p className={style.client_item_title}>청주대학교</p>
                    <ul className={style.client_item_desc}>
                      <li>원격강의를 위해 LMS와 Webex 연동 지원</li>
                    </ul>
                  </article>
                </div>
                <div className={style.client_item}>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/begate/ci_won.png`}
                    alt=""
                  />
                  <article className={style.client_item_article}>
                    <p className={style.client_item_title}>원불교 교종</p>
                    <ul className={style.client_item_desc}>
                      <li>원격미팅을 위한 그룹웨어와 Zoom 연동 지원</li>
                    </ul>
                  </article>
                </div>
              </div>
            </div>
          </section>
          <section
            className={style.promotion_section}
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/solution/begate/promotion_bg.png')",
            }}
          >
            <div
              className={style.promotion_item}
              style={{
                backgroundImage:
                  "url('" +
                  process.env.REACT_APP_CLIENT_URL +
                  "img/solution/begate/promotion_plan_card.png')",
              }}
            >
              <p className={style.promotion_title}>
                기존 시스템에{isMobile ? <br /> : " "}완벽하게 연동되는
                {isMobile ? <br /> : " "}맞춤형 화상회의 게이트웨이,
                {isMobile ? <br /> : " "}
                <strong>Be Gate!</strong>
              </p>
              <article className={style.promotion_description}>
                {isMobile ? (
                  <>
                    <p>사내 플랫폼이나 병원 시스템에</p>
                    <p>손쉽게 통합되어, Zoom, Webex 등</p>
                    <p>다양한 회의 도구를 자동으로 연결합니다.</p>
                    <p>Be Gate와 함께라면,</p>
                    <p>복잡한 연동 없이도 지금 바로</p>
                    <p>스마트한 협업 환경을 구축할 수 있습니다.</p>
                  </>
                ) : (
                  <>
                    <p>
                      사내 플랫폼이나 병원 시스템에 손쉽게 통합되어, Zoom, Webex
                      등 다양한 회의 도구를 자동으로 연결합니다.
                    </p>
                    <p>
                      Be Gate와 함께라면, 복잡한 연동 없이도 지금 바로 스마트한
                      협업 환경을 구축할 수 있습니다.
                    </p>
                  </>
                )}
              </article>
            </div>
          </section>
          {props.type === "popup" ? (
            <div style={{ marginBottom: "70px" }}>
              <Consult />
            </div>
          ) : (
            <div className={style.device_consult_wrapper}>
              <Questions />
            </div>
          )}
        </section>
      </section>
    </>
  );
}

export default BeGate;
